module.exports = {"name":"graylog-plugin-auditlog","version":"2.5.1","description":"","repository":{"type":"git","url":"graylog-plugin-auditlog"},"scripts":{"build":"webpack --bail"},"keywords":["graylog"],"author":"Graylog, Inc. <hello@graylog.com>","license":"UNLICENSED","private":true,"dependencies":{"urijs":"^1.17.0"},"devDependencies":{"graylog-web-plugin":"file:../graylog2-server/graylog2-web-interface/packages/graylog-web-plugin"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 149
// module chunks = 0